// import * as Highcharts from 'highcharts';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { BasemodelService } from '../basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class HighchartsService {
  environment: any;
  constructor(public http: HttpClient, private base: BasemodelService) { }
  roles: any = [];

  getRoles() {
    return this.roles;
  }

  setRoles(roles: any) {
    this.roles = roles;
    for (let i = 0; i <= this.roles.length - 1; i++) {

      if (this.roles[i].basemodule == "StudentAttendance") {
        localStorage.setItem("StudentAttendance", this.roles[i].baseurl);
      }
      else if (this.roles[i].basemodule == "CCTVDashboard") {
        localStorage.setItem("CCTVDashboard", this.roles[i].baseurl);
        // localStorage.setItem("WebService", this.roles[i].baseurl);
      }
      else if (this.roles[i].basemodule == "WebService") {
        localStorage.setItem("WebService", this.roles[i].baseurl);
      }
      else if (this.roles[i].basemodule == 'MasterService') {
        localStorage.setItem("MasterService", this.roles[i].baseurl);
      }
      else if (this.roles[i].basemodule == 'MerakiDashboard') {
        localStorage.setItem("MerakiDashboard", this.roles[i].baseurl);
      }
      else if (this.roles[i].basemodule == 'MisService') {
        localStorage.setItem("MisService", this.roles[i].baseurl);
      }
    }
  }

  public token = '';
  getDashboardDetails() {
    // window.alert(environment.apiUrl)
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/overall',)
  }
  getconnecteddetails() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/top5Connected',)
  }
  getnotconnecteddetails() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/top5NotConnected',)
  }
  getvideostreaming() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/top5VideoStreaming',)
  }
  getvideonotstreaming() {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/top5VideoNotStreaming')
  }

  modulebaseurl() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.employeeURL + '/jwtV2/api/common/moduleBaseUrls', { headers })
  }

  // SCHOOL DASHBOARD DETAILS //
  getSchoolDashboardDetails(businessType: string) {
    return this.http.get<any>(environment.cctvURL + '/ses/cctv/dashboard/segmentwise?businessType=' + businessType)
  }

}
